<template>
  <min class="mmd_shahkoi hoosein_noori mmd_safarpoor">
    <heder />
    <div class="app">
      <router-view />
    </div>
    <Footer />
  </min>
</template>

<script>
import Footer from './components/layout/footer.vue';
import Heder from './components/layout/heder.vue';

export default {
  components: {
    Heder,
    Footer
  }
}
</script>

<style>
/* توی فایل global.css یا App.vue */
main,
.main-content {
  padding-bottom: 80px;
  /* یا pb-20 توی تیلویند */
}

min {
  width: 100%;
  /* padding: 0 100px; */
  min-height: 100vh
}

/* @import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap'); */

@font-face {
  font-family: 'BYekan';
  src: url('@/assets/BYekan+.ttf') format('opentype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}


* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: BYekan;
}
</style>